<div class="page-layout carded fullwidth inner-scroll">
  <div class="center">
    <div class="header" fxLayout="row" fxLayoutAlign="space-between center">
      <span class="h1" [translate]="'SEGMENTS.TITLE'"> Segments </span>

      <div class="page-buttons" fxHide.xs>
        <button
          mat-stroked-button
          matTooltip="{{ 'SEGMENTS.ADD' | translate }}"
          [disabled]="!hasCreateSegmentPermission"
          (click)="openDialog()"
        >
          <i
            matTooltipPosition="left"
            class="angularjs-fuse-icon icon-plus"
            [matTooltip]="'SEGMENTS.PERMISSIONS.NO_CREATE' | translate"
            [matTooltipDisabled]="hasCreateSegmentPermission"
          ></i>
        </button>

        <button
          *ngIf="filtered"
          mat-stroked-button
          matTooltip="{{ 'SEGMENTS.FILTER_CLEAR' | translate }}"
          (click)="clearFilters()"
        >
          <i class="angularjs-fuse-icon icon-filter-remove"></i>
        </button>

        <button
          mat-stroked-button
          matTooltip="{{ 'SEGMENTS.FILTER' | translate }}"
          (click)="toggleFilterSegmentsSidebar()"
        >
          <i class="angularjs-fuse-icon icon-filter"></i>
        </button>

        <button mat-stroked-button matTooltip="{{ 'SEGMENTS.RELOAD' | translate }}" (click)="reload()">
          <i class="angularjs-fuse-icon icon-reload small"></i>
        </button>
      </div>

      <div class="page-buttons" fxShow="false" fxShow.xs>
        <button mat-stroked-button [matMenuTriggerFor]="menuSegments">
          <mat-icon class="accent-500-fg">keyboard_arrow_down</mat-icon>
        </button>

        <mat-menu #menuSegments>
          <button
            [disabled]="!hasCreateSegmentPermission"
            mat-menu-item
            fxLayout="row"
            fxLayoutAlign="start center"
            (click)="openDialog()"
          >
            <i class="angularjs-fuse-icon icon-plus mr-4"></i>
            <span [translate]="'SEGMENTS.ADD'">Add</span>
          </button>

          <button *ngIf="filtered" mat-menu-item fxLayout="row" fxLayoutAlign="start center" (click)="clearFilters()">
            <i class="angularjs-fuse-icon icon-filter-remove mr-4"></i>
            <span [translate]="'SEGMENTS.FILTER_CLEAR'">Clear filter</span>
          </button>

          <button mat-menu-item fxLayout="row" fxLayoutAlign="start center" (click)="toggleFilterSegmentsSidebar()">
            <i class="angularjs-fuse-icon icon-filter mr-4"></i>
            <span [translate]="'SEGMENTS.FILTER'">Filter</span>
          </button>

          <button mat-menu-item fxLayout="row" fxLayoutAlign="start center" (click)="reload()">
            <i class="angularjs-fuse-icon icon-reload small mr-4"></i>
            <span [translate]="'SEGMENTS.RELOAD'">Reload</span>
          </button>
        </mat-menu>
      </div>
    </div>

    <div class="content-card datatable">
      <mat-table
        #datatable
        class="datatable__table"
        [dataSource]="segments"
        fusePerfectScrollbar
        matSort
        [matSortDisableClear]="true"
      >
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'SEGMENTS.HEADER.NAME' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let segment" fxFlex.xs="100">
            <span class="mobile-label">{{ 'SEGMENTS.HEADER.NAME' | translate }}</span>
            <div
              class="label-color"
              [class.red-500-bg]="segment.archived"
              [class.green-500-bg]="!segment.archived"
            ></div>
            {{ segment.name }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="createdAt">
          <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="12">
            {{ 'SEGMENTS.HEADER.CREATED_AT' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let segment" fxFlex="12" fxFlex.xs="100">
            <span class="mobile-label">{{ 'SEGMENTS.HEADER.CREATED_AT' | translate }}</span>
            {{ segment.createdAt | date: 'dd/MM/yyyy HH:mm' }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="edit">
          <mat-header-cell *matHeaderCellDef fxFlex="7">
            {{ 'SEGMENTS.HEADER.ACTIONS' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let segment" fxFlex="7" fxFlex.xs="100" fxLayoutAlign.xs="center center">
            <span class="mobile-label uppercase">{{ 'SEGMENTS.EDIT' | translate }}</span>
            <button
              mat-icon-button
              [matTooltip]="(hasEditSegmentPermission ? 'SEGMENTS.EDIT' : 'SEGMENTS.VIEW') | translate"
              (click)="openDialog(segment.id)"
            >
              <img src="assets/images/icons/new_icon_edit_action.svg" alt="edit segment" />
            </button>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="noData">
          <mat-footer-cell
            *matFooterCellDef
            [attr.colspan]="displayedColumns.length"
            fxLayout="column"
            fxLayoutAlign="center center"
          >
            {{ 'SEGMENTS.NO_DATA' | translate }}
          </mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="loading">
          <mat-footer-cell
            *matFooterCellDef
            [attr.colspan]="displayedColumns.length"
            fxLayout="column"
            fxLayoutAlign="center center"
          >
            <div class="p-24" fxLayout="column" fxLayoutAlign="center center">
              <mat-spinner color="primary" diameter="64" class="mb-24"></mat-spinner>
              {{ 'SEGMENTS.LOADING' | translate }}
            </div>
          </mat-footer-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns" [class.display-none]="loading"></mat-row>
        <mat-footer-row *matFooterRowDef="['noData']" [hidden]="loading || segments?.length"></mat-footer-row>
        <mat-footer-row *matFooterRowDef="['loading']" [hidden]="!loading"></mat-footer-row>
      </mat-table>
      <mat-paginator [length]="totalCount" [pageSizeOptions]="[25, 50, 100, 200, 250]"></mat-paginator>
    </div>
  </div>
</div>

<fuse-sidebar name="filterSegments" position="right" lockedOpen="true">
  <filters-segments class="sidebar-filter"></filters-segments>
</fuse-sidebar>
